import { Component, input, Input, InputSignal, OnInit } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import { CommonModule, DatePipe } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';
import {
  LocationDataPreviewComponent
} from '../../common/location-data-section/components/location-data-preview/location-data-preview.component';

@Component({
  selector: 'app-location-reconstruction-of-exit-preview',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    LabelComponent,
    ApplicationDataPreviewComponent,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    ApplicantPreviewComponent,
    DecisionDataPreviewComponent,
    ContractorDataPreviewComponent,
    LocationDataPreviewComponent
  ],
  templateUrl: './location-reconstruction-of-exit-preview.component.html'
})
export class LocationReconstructionOfExitPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  constructor() {
  }

  public ngOnInit(): void {
  }

}
